<div class="flex-shrink-0 rounded-lg flex items-center justify-center"
     [ngClass]="[badge.bgClass, sizeClasses]"
     [matTooltip]="badge.text">
  <mat-icon 
    [class]="iconSizeClass"
    [ngClass]="badge.iconClass"
    [svgIcon]="badge.icon">
  </mat-icon>
</div>
